import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  categoryName: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  coverImage,
  category,
  categoryName,
  author,
  publishDate,
  readTime,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-white rounded-lg border border-foreground-100 overflow-hidden transition-all duration-300 hover:border-foreground-200">
      <Link to={`/article/${slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${category}`}
            className="text-xs font-medium px-2 py-1 rounded-full bg-foreground-100 text-foreground-700 hover:bg-foreground-200 transition-colors whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400">{readTime}</span>
        </div>
        <Link to={`/article/${slug}`}>
          <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-foreground-700 transition-colors">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-foreground-400">
            <span>{author}</span>
            <span>·</span>
            <span>{publishDate}</span>
          </div>
          <div className="flex items-center gap-1.5">
            {tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="text-xs text-foreground-500 bg-foreground-50 px-1.5 py-0.5 rounded"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}